query instanciaSelect($where: InstanciaModelFilterInput) {
    data: instancias(where: $where, order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}